// @TODO biome-ignore lint/suspicious/noExplicitAny:
export function asyncLimit<T extends (...args: any) => Promise<any>>(fn: T, n: number): T {
  let pendingPromises = [] as Promise<ReturnType<T>>[];

  return async function limitedFunction(this: ThisType<T>, ...args: Parameters<T>) {
    while (pendingPromises.length >= n) {
      await Promise.race(pendingPromises);
    }

    const p = fn.apply<ThisType<T>, Parameters<T>, Promise<ReturnType<T>>>(this, args);

    pendingPromises.push(p);
    await p;
    pendingPromises = pendingPromises.filter((promise) => promise !== p);

    return p;
  } as T;
}

export async function sleep(timeout: number) {
  return await new Promise((resolve) => setTimeout(resolve, timeout));
}
